import { store } from '@/state/store';
import { LOCAL__ui_grids2d_set_current_cell } from '@/state/ui/image/LOCAL__ui_grids2d_set_current_cell';
import { LOCAL__ui_grids2d_set_current_cell_neigbours } from '@/state/ui/image/LOCAL__ui_grids2d_set_current_cell_neigbours';
import { DTO__grid2d_generation } from '@shared/dto/grid2d/DTO__grid2d_generation';
import { DTO__grid2d_cell_generation } from '@shared/dto/grid2d_cell/DTO__grid2d_cell_generation';

export function FN_GRID2D_GALLERY_GENERATION__set_cell_current(grid2d: DTO__grid2d_generation, cell: DTO__grid2d_cell_generation) {
  // 1. Set the current active cell
  store.dispatch(LOCAL__ui_grids2d_set_current_cell(cell));

  const chunk = grid2d.get_generation_chunk();
  const neighbors_grid: DTO__grid2d_cell_generation[][] = [];

  // Determine dynamic X bounds (ensure a 3-wide window)
  let start_x = cell.x - 1;
  let end_x = cell.x + 1;

  if (cell.x === chunk.cells_amount__x - 1) {
    // If it's the last item on X
    start_x = cell.x - 2;
    end_x = cell.x;
  } else if (cell.x === 0) {
    // Just in case it's the first item on X
    start_x = cell.x;
    end_x = cell.x + 2;
  }

  // Determine dynamic Y bounds (ensure a 3-high window)
  let start_y = cell.y - 1;
  let end_y = cell.y + 1;

  if (cell.y === chunk.cells_amount__y - 1) {
    // If it's the last item on Y
    start_y = cell.y - 2;
    end_y = cell.y;
  } else if (cell.y === 0) {
    // Just in case it's the first item on Y
    start_y = cell.y;
    end_y = cell.y + 2;
  }

  // Ensure bounds don't crash if the total chunk size is smaller than 3
  start_x = Math.max(0, start_x);
  end_x = Math.min(chunk.cells_amount__x - 1, end_x);
  start_y = Math.max(0, start_y);
  end_y = Math.min(chunk.cells_amount__y - 1, end_y);

  // 2. Loop through the dynamically calculated 3x3 region
  for (let target_y = start_y; target_y <= end_y; target_y++) {
    const row: DTO__grid2d_cell_generation[] = [];

    for (let target_x = start_x; target_x <= end_x; target_x++) {
      const neighbor = chunk.get_cell_by_coordinates(target_x, target_y);
      row.push(neighbor);
    }
    neighbors_grid.push(row);
  }

  // 3. Dispatch the 2D array of up to 3x3 neighbors to the store
  store.dispatch(LOCAL__ui_grids2d_set_current_cell_neigbours(neighbors_grid));
}
